import { Checkbox } from '@material-ui/core';
import { getContractStatusCms } from 'app/modules/cms/service/store/selectors';
import ActionComponent from 'app/shared/components/common/action-component';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { getDate } from 'app/shared/util/date-utils';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ContractDetails from './contract-details';
import './style.scss';

const DesktopAssignmentContract = props => {
  const {
    subscriptionList,
    dataConf,
    accoutAssignementCms,
    refHeight,
    avatar,
    avatarTitle,
    getNotAttachedSusbscriptionList,
    chekedFunc,
    nextView
  } = props;

  const contractCustomerCms: any = useSelector(getContractStatusCms);
  return (
    <>
      <div className="desktop-assignement-contract">
        <div ref={refHeight}>
          <AvatarWithBadge
            avatar={avatar}
            hideButton={true}
            title={[avatarTitle]}
          />
        </div>
        <div style={{ height: `calc(100% - 180px)` }}>
          <div className="insured-desktop-list">
            {subscriptionList
              .filter(subscription => subscription.valid === false)
              .map((item, key) => {
                return (
                  <ContractDetails
                    key={key}
                    subscription={item.number}
                    startDate={getDate(item.startDate)}
                    phoneNumber={item.tel}
                    changeMineSubscription={getNotAttachedSusbscriptionList}
                    imei={item.imei}
                    accoutAssignementCms={accoutAssignementCms}
                    contractCustomerCms={contractCustomerCms}
                    status={item?.status}
                    brand={item?.brand}
                    model={item?.model}
                  />
                );
              })}
          </div>
          <div className="d-flex justify-content-end">
            <ActionComponent
              label={accoutAssignementCms?.assaignement_contract?.btn_next_label}
              style={'Mobile1'}
              action={'NEXT_VIEW'}
              ActionData={dataConf.actioDataList}
              param={{ specificAction: nextView }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopAssignmentContract;
